import React, { useState } from "react";
import Footer from "../../components/footer/Footer";
import Box from "@mui/material/Box";
import "./Summarize.css";
import { IoCloudUploadOutline } from "react-icons/io5";
import { Button } from "@mui/material";
import axios from "axios";
import { Spinner } from "react-bootstrap";

function Humanize() {
    const [humanize, setHumanize] = useState("");
    const [output, setOutput] = useState("You will get summary here!");
    const [loading, setLoading] = useState(false);
    const countWords = (text) => {
        const words = text.trim().split(/\s+/);
        return words.length;
    };
    const handleAICheck = async () => {
        setLoading(true);
        const formData = new FormData();
        formData.append("text", humanize);
        await axios
            .post("http://localhost:5000/humanize", formData)
            .then((response) => {
                console.log(response);
                let output = response.data.ai21labs.result;
                setOutput(output);
            })
            .finally(() => {
                setLoading(false);
            });
        // setOutput(`AI checked. Results here.`);
    };

    return (
        <>
            <div className="TextAreaDiv">
                <Box className="InputBox">
                    <textarea
                        name="AiCheckerText"
                        id="aichecker"
                        cols="30"
                        rows="10"
                        className="inputChecker"
                        placeholder="Input Your first Text here..."
                        value={humanize}
                        onChange={(e) => {
                            setHumanize(e.target.value);
                        }}
                    ></textarea>
                    <div className="buttonContainer">
                        <label htmlFor="uploadDoc" className="uploadButton">
                            <IoCloudUploadOutline className="uploadIcon" />
                            Upload a Doc
                            <input
                                type="file"
                                name="UploadDoc"
                                id="uploadDoc"
                                className="uploadInput"
                            />
                        </label>
                        <Button
                            className="AiCheckerButton"
                            variant="contained"
                            onClick={handleAICheck}
                        >
                            {loading && (
                                <Spinner
                                    as="span"
                                    animation="grow"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    style={{
                                        marginRight: 20,
                                        color: "#fff",
                                    }}
                                />
                            )}
                            {loading ? "Humanizing..." : "Humanize"}
                        </Button>
                    </div>
                    <p className="wordCount">
                        Word Count: {countWords(humanize)}
                    </p>
                </Box>
                <Box className="OutputBox">
                    <textarea
                        name="AiCheckerText"
                        id="aichecker"
                        cols="30"
                        rows="10"
                        readOnly
                        value={output}
                        className="OutputText"
                    ></textarea>
                </Box>
            </div>
            <Footer />
        </>
    );
}

export default Humanize;
